import React from 'react';
import {isFromAccountingTeam, isFromTechTeam} from '../../../auth/UserPermissions';
import Box from '@amzn/awsui-components-react/polaris/box';
import PermissionsModal from '../../PermissionsModal';
import SpaceBetween from '@amzn/awsui-components-react/polaris/space-between';
import ButtonDropdown from '@amzn/awsui-components-react/polaris/button-dropdown';
import {TestFeatureType} from '../model/TestFeatureType';

export default function TestCaseFunctionalityDropDown(props) {
    const [hasAccess] = React.useState(isFromTechTeam() || isFromAccountingTeam());
    const [selectedId, setSelectedId] = React.useState("");

    const onSelectionChange = (event: CustomEvent) => {
        event.preventDefault();

        const selection = event.detail.id;
        const featureType: TestFeatureType = selection as TestFeatureType;

        setSelectedId(selection);
        props.setFeatureType(featureType);
    }

    return (
        <Box>
            {!hasAccess && <PermissionsModal hasPageAccess={hasAccess}/>}
            {hasAccess && <SpaceBetween direction='vertical' size='xl'>
                <ButtonDropdown
                    onItemClick={onSelectionChange}
                    items={[
                        {
                            id: TestFeatureType[TestFeatureType.REGRESSION_DEVO],
                            text: "REGRESSION_DEVO",
                            description: "Regression Test (DEVO): Compare the output of DEVO stack to output of PROD stack",
                        },
                        {
                            id: TestFeatureType[TestFeatureType.REGRESSION_UAT],
                            text: "REGRESSION_UAT",
                            description: "Regression Test (UAT): Compare the output of UAT stack to output of PROD stack",
                        },
                        {
                            id: TestFeatureType[TestFeatureType.PREVIEW_DEVO],
                            text: "PREVIEW_DEVO",
                            description: "PREVIEW (DEVO): Review the output of DEVO stack, without any comparison to other stacks",
                        },
                        {
                            id: TestFeatureType[TestFeatureType.PREVIEW_UAT],
                            text: "PREVIEW_UAT",
                            description: "PREVIEW (UAT): Review the output of UAT stack, without any comparison to other stacks",
                        },
                        {
                            id: TestFeatureType[TestFeatureType.PREVIEW_PROD],
                            text: "PREVIEW_PROD",
                            description: "PREVIEW (PROD): Review the output of PROD stack, without any comparison to other stacks",
                        },
                    ]}
                >
                    {selectedId}
                </ButtonDropdown>
            </SpaceBetween>}
        </Box>
    );
}